import { ping } from './ping';

const hostnamePattern = /^([a-z]{2,6}-\d+)_cms\.qa\.megogo\.net/i;
const searchKeyName = 'i9e:build';

export {
  applyCustomBuild
};

/**
 *
 * @param location
 * @return {(function(Config): Promise<Config>)}
 */
function applyCustomBuild (location) {
  const customBuild = getCustomBuildKey(location);

  if (null === customBuild) {
    return config => config;
  }


  return patchConfig;

  /**
   *
   * @param {Config} config
   * @return {Promise<Config>}
   */
  function patchConfig(config) {
    const url = config.interactive_url;
    const customUrl = url.replace(/\/([^/]+)(?:\/(?:site|stv|mobile))?\/index.html/, function (str, buildKey) {
      return str.replace(buildKey, customBuild.toLowerCase());
    });

    return ping(customUrl)
      .then(() => {
        return {
          ...config,
          interactive_url: customUrl
        };
      }, () => config);
  }
}

const either = (fn, failure) => {
  try {
    return fn();
  } catch (e) {
    return failure;
  }
};

const getSearchKey = ({ search }) => {
  const searchParams = new URLSearchParams(search);
  return searchParams.get(searchKeyName);
};

const getHostnameKey = ({ hostname }) => {
  const [ , hostKey = null ] = hostnamePattern.exec(hostname);
  return hostKey;
};

/**
 * @param {Location} location
 * @return {string|null}
 */
function getCustomBuildKey (location) {
  return either(() => getSearchKey(location), null)
    || either(() => getHostnameKey(location), null);
}
